// Curated points valuation table for Peak Points.
// Values are estimated cents-per-point (cpp). lowCpp = a sensible floor
// (cash/portal), highCpp = a realistic ceiling via smart transfers.
// These are editorial estimates, not offers, and change over time.

export const PROGRAMS = [
  { id: "chase", name: "Chase Ultimate Rewards", type: "Bank", lowCpp: 1.25, highCpp: 2.05, tip: "Transfer to Hyatt or United for the biggest wins." },
  { id: "amex", name: "Amex Membership Rewards", type: "Bank", lowCpp: 1.0, highCpp: 2.0, tip: "Transfer to airline partners; avoid cashing out at 0.6¢." },
  { id: "capitalone", name: "Capital One Miles", type: "Bank", lowCpp: 1.0, highCpp: 1.85, tip: "Transfer to partners beats the 'erase travel' option." },
  { id: "citi", name: "Citi ThankYou Points", type: "Bank", lowCpp: 1.0, highCpp: 1.8, tip: "Transfer to airline partners for premium cabins." },
  { id: "bilt", name: "Bilt Rewards", type: "Bank", lowCpp: 1.25, highCpp: 2.05, tip: "Great transfer ratios; skip the gift-card option." },
  { id: "wellsfargo", name: "Wells Fargo Rewards", type: "Bank", lowCpp: 1.0, highCpp: 1.65, tip: "Solid for cash back; transfers are limited." },
  { id: "delta", name: "Delta SkyMiles", type: "Airline", lowCpp: 1.1, highCpp: 1.5, tip: "Watch for flash sales; value is dynamic." },
  { id: "united", name: "United MileagePlus", type: "Airline", lowCpp: 1.2, highCpp: 1.6, tip: "Excellent for partner award flights." },
  { id: "american", name: "American AAdvantage", type: "Airline", lowCpp: 1.2, highCpp: 1.7, tip: "Best for premium partner redemptions." },
  { id: "southwest", name: "Southwest Rapid Rewards", type: "Airline", lowCpp: 1.3, highCpp: 1.5, tip: "Fixed value; pair with Companion Pass." },
  { id: "hyatt", name: "World of Hyatt", type: "Hotel", lowCpp: 1.5, highCpp: 2.3, tip: "The strongest hotel points out there." },
  { id: "marriott", name: "Marriott Bonvoy", type: "Hotel", lowCpp: 0.7, highCpp: 0.9, tip: "Use the 5th-night-free perk to boost value." },
  { id: "hilton", name: "Hilton Honors", type: "Hotel", lowCpp: 0.5, highCpp: 0.7, tip: "Earn a lot, spend a lot — go for premium nights." },
  { id: "cashback", name: "Cash Back", type: "Cash", lowCpp: 1.0, highCpp: 1.0, tip: "Simple and safe — always worth exactly 1¢." },
];

export const REDEMPTION_METHODS = [
  {
    id: "transfer",
    label: "Transfer to Partners",
    cpp: 2.0,
    verdict: "Best value",
    best: true,
    note: "Move points to airline & hotel partners for premium flights and stays. Highest ceiling, a little more effort.",
  },
  {
    id: "travel",
    label: "Travel Portal",
    cpp: 1.25,
    verdict: "Solid",
    best: false,
    note: "Book flights and hotels through your card's portal, often at a small bonus over cash. Easy and reliable.",
  },
  {
    id: "cash",
    label: "Cash / Statement Credit",
    cpp: 1.0,
    verdict: "Reliable",
    best: false,
    note: "Predictable and flexible, but you usually leave value on the table versus travel.",
  },
  {
    id: "giftcards",
    label: "Gift Cards",
    cpp: 0.8,
    verdict: "Usually skip",
    best: false,
    note: "Convenient, but points are often worth less than a penny each here. Only if you'd buy the gift card anyway.",
  },
];

export const fmtUSD = (n) =>
  n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
